import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 10,
	fill: "none",
	viewBox: "0 0 16 10",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#1D1B20",
		d: "M6.558 10V9h2.865v1H6.558Zm-3.75-4.5v-1h10.365v1H2.808ZM0 1V0h16v1H0Z"
	})
});
export { SvgFilter as ReactComponent };
